module.exports = __webpack_public_path__ + "static/media/pen2.b50dbb0d.png";